module.exports = __webpack_public_path__ + "img/ring_r_s_0_0@3x.ac9c717d.png";